(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/internal/draws.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/internal/draws.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
const productMapping = svs.numbergames.productMapping;
const {
  DRAW_STATES
} = svs.numbergames.draws.constants;
const logger = svs.numbergames.draws.logger;
const {
  fetchCurrentDraws,
  fetchDrawsByDrawId
} = svs.numbergames.draws.internal;
const {
  fetchJackpots,
  fetchJackpotsByProductDraw
} = svs.numbergames.jackpot;
function toProductDrawIds(_ref) {
  let {
    products,
    addJoker
  } = _ref;
  if (!Array.isArray(products)) products = [products];
  const productDrawIds = products.flatMap(product => productMapping.getAllDrawIds(product));
  if (addJoker) {
    [...productDrawIds].forEach(drawId => {
      if (productMapping.hasJoker(drawId)) productDrawIds.push(productMapping.getJokerDrawId(drawId));
    });
  }
  return Array.from(new Set(productDrawIds));
}
function formatDrawOptions(drawOptions) {
  const toDayNumber = day => typeof day === 'string' ? ['sö', 'må', 'ti', 'on', 'to', 'fr', 'lö'].indexOf(day.toLowerCase().substring(0, 2)) : day;
  const isDayNumber = day => typeof day === 'number' && day >= 0 && day <= 6;
  if (!Array.isArray(drawOptions)) {
    drawOptions = [drawOptions];
  }
  return drawOptions.filter(drawOption => !drawOption.sameRegCloseDayAs).concat(drawOptions.filter(drawOption => drawOption.sameRegCloseDayAs)).map(_ref2 => {
    var _days$map;
    let {
      id,
      product,
      days,
      sameRegCloseDayAs
    } = _ref2;
    return {
      id,
      product: productMapping.getProductDrawId(product),
      days: days === null || days === void 0 || (_days$map = days.map) === null || _days$map === void 0 ? void 0 : _days$map.call(days, toDayNumber).filter(isDayNumber),
      sameRegCloseDayAs: productMapping.getProductDrawId(sameRegCloseDayAs)
    };
  });
}
var _draws = new WeakMap();
var _firstPlayableDraws = new WeakMap();
var _jackpots = new WeakMap();
var _clientTimeOffset = new WeakMap();
var _fetching = new WeakMap();
var _fetchingJackpots = new WeakMap();
var _fetch = new WeakMap();
var _verifyDraw = new WeakMap();
var _update = new WeakMap();
var _updateDraws = new WeakMap();
var _updateFirstPlayableDraws = new WeakMap();
var _findCorrespondingJokerDraw = new WeakMap();
var _fetchJackpots = new WeakMap();
class Draws {
  constructor() {
    let {
      draws: _draws2 = [],
      jackpots: _jackpots2,
      serverTime
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classPrivateFieldInitSpec(this, _draws, productMapping.getAllDrawIds().reduce((acc, productDrawId) => Object.assign(acc, {
      [productDrawId]: {}
    }), {}));
    _classPrivateFieldInitSpec(this, _firstPlayableDraws, productMapping.getAllDrawIds().reduce((acc, productDrawId) => Object.assign(acc, {
      [productDrawId]: undefined
    }), {}));
    _classPrivateFieldInitSpec(this, _jackpots, void 0);
    _classPrivateFieldInitSpec(this, _clientTimeOffset, 0);
    _classPrivateFieldInitSpec(this, _fetching, void 0);
    _classPrivateFieldInitSpec(this, _fetchingJackpots, void 0);
    _classPrivateFieldInitSpec(this, _fetch, async drawIds => {
      if (!Array.isArray(drawIds)) return;
      const promise = (async () => {
        try {
          await _classPrivateFieldGet(_fetching, this);
        } catch (error) {
          logger.info('Previous fetch failed', error);
        }
        let currentDraws = [];
        let closedDraws = [];
        let drawsToFetch = [];
        const currentDrawsToFetch = drawIds.filter(drawId => !_classPrivateFieldGet(_verifyDraw, this).call(this, _classPrivateFieldGet(_firstPlayableDraws, this)[drawId === null || drawId === void 0 ? void 0 : drawId.productDrawId])).map(drawId => drawId.productDrawId);
        if (currentDrawsToFetch.length) {
          try {
            ({
              currentDraws,
              closedDraws,
              drawsToFetch
            } = await fetchCurrentDraws(currentDrawsToFetch));
          } catch (error) {
            logger.warn('Draws.#fetchCurrentDraws failed to fetch current draws', error);
            throw new Error("Failed to fetch current draws");
          }
        }
        drawsToFetch = drawsToFetch.concat(drawIds).filter(drawId => drawId.drawNumber && !_classPrivateFieldGet(_verifyDraw, this).call(this, drawId));
        if (drawsToFetch.length) {
          try {
            const draws = await fetchDrawsByDrawId(drawsToFetch);
            currentDraws.push(...draws.draws);
            closedDraws.push(...draws.closedDraws);
          } catch (error) {
            logger.warn('Draws.#fetchDrawsByDrawId failed to fetch draws by draw id', error);
            throw new Error("Failed to fetch future draws");
          }
        }
        if (currentDraws.length || closedDraws.length) {
          _classPrivateFieldGet(_update, this).call(this, {
            draws: currentDraws,
            closedDraws
          });
        }
      })();
      _classPrivateFieldSet(_fetching, this, promise);
      return await promise;
    });
    _classPrivateFieldInitSpec(this, _verifyDraw, drawId => {
      var _classPrivateFieldGet2;
      if (!drawId) return;
      const draw = (_classPrivateFieldGet2 = _classPrivateFieldGet(_draws, this)[drawId.productDrawId]) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2[drawId.drawNumber];
      if (draw) {
        switch (draw.drawStateId) {
          case DRAW_STATES.DEFINED:
            {
              if (this.clientNow < new Date(draw.regOpenTime).getTime()) {
                return true;
              }
              break;
            }
          case DRAW_STATES.OPEN:
            {
              if (this.clientNow < new Date(draw.regCloseTime).getTime()) {
                return true;
              }
              break;
            }
          default:
            {
              var _classPrivateFieldGet3;
              if (draw.drawNumber < ((_classPrivateFieldGet3 = _classPrivateFieldGet(_firstPlayableDraws, this)[drawId.productDrawId]) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.drawNumber)) {
                return true;
              }
              break;
            }
        }
        logger.info("DrawStateId ".concat(draw.drawStateId, " is out of date for ").concat(draw.productDrawId, " draw ").concat(draw.drawNumber, "."));
      }
    });
    _classPrivateFieldInitSpec(this, _update, _ref3 => {
      let {
        draws,
        closedDraws
      } = _ref3;
      _classPrivateFieldGet(_updateDraws, this).call(this, {
        draws,
        closedDraws
      });
      _classPrivateFieldGet(_updateFirstPlayableDraws, this).call(this);
    });
    _classPrivateFieldInitSpec(this, _updateDraws, _ref4 => {
      let {
        draws = [],
        closedDraws = []
      } = _ref4;
      closedDraws.map(draw => _objectSpread(_objectSpread({}, draw), {}, {
        productDrawId: productMapping.getProductDrawId(draw.productId),
        productItsId: productMapping.getProductItsId(draw.productId)
      })).forEach(closed => {
        const productDraws = _classPrivateFieldGet(_draws, this)[closed.productDrawId];
        const closeDraw = draw => {
          Object.assign(productDraws[draw.drawNumber], draw, {
            drawStateId: DRAW_STATES.CLOSED
          });
          logger.info("Closed ".concat(draw.productDrawId, " draw ").concat(draw.drawNumber));
        };
        if (productDraws[closed.drawNumber]) {
          closeDraw(closed);
          Object.values(productDraws).filter(draw => draw.drawNumber < closed.drawNumber && draw.drawStateId < DRAW_STATES.CLOSED).forEach(closeDraw);
        }
      });
      draws.map(draw => _objectSpread(_objectSpread({}, draw), {}, {
        productDrawId: productMapping.getProductDrawId(draw.productId),
        productItsId: productMapping.getProductItsId(draw.productId)
      })).forEach(draw => {
        const productDraws = _classPrivateFieldGet(_draws, this)[draw.productDrawId];
        if (!productDraws[draw.drawNumber]) {
          Object.assign(productDraws, {
            [draw.drawNumber]: draw
          });
        } else {
          const prevDrawStateId = productDraws[draw.drawNumber].drawStateId;
          Object.assign(productDraws[draw.drawNumber], draw);
          if (prevDrawStateId !== draw.drawStateId) {
            logger.info("Updated ".concat(draw.productDrawId, " draw ").concat(draw.drawNumber, ". drawStateId changed from ").concat(prevDrawStateId, " to ").concat(draw.drawStateId));
          }
        }
      });
    });
    _classPrivateFieldInitSpec(this, _updateFirstPlayableDraws, () => {
      Object.keys(_classPrivateFieldGet(_firstPlayableDraws, this)).forEach(productDrawId => {
        let productDraw = Object.values(_classPrivateFieldGet(_draws, this)[productDrawId]).find(draw => draw.drawStateId === DRAW_STATES.OPEN);
        if (!productDraw) {
          const drawNumbers = Object.values(_classPrivateFieldGet(_draws, this)[productDrawId]).filter(draw => draw.drawStateId < DRAW_STATES.CLOSED).map(draw => draw.drawNumber);
          const drawNumber = Math.min(...drawNumbers);
          productDraw = _classPrivateFieldGet(_draws, this)[productDrawId][drawNumber];
        }
        if (productDraw) {
          const jokerDraw = _classPrivateFieldGet(_findCorrespondingJokerDraw, this).call(this, productDraw);
          _classPrivateFieldGet(_firstPlayableDraws, this)[productDrawId] = _objectSpread(_objectSpread({}, productDraw), jokerDraw && {
            jokerDraw
          });
        }
      });
      logger.debug("First playable draws: ".concat(Object.entries(_classPrivateFieldGet(_firstPlayableDraws, this)).filter(_ref5 => {
        let [, draw] = _ref5;
        return draw;
      }).map(_ref6 => {
        let [productDrawId, draw] = _ref6;
        return "".concat(productDrawId, ": ").concat(draw.drawNumber);
      }).join(', ')));
    });
    _classPrivateFieldInitSpec(this, _findCorrespondingJokerDraw, productDraw => {
      if (!productDraw) return;
      const jokerDrawId = productMapping.getJokerDrawId(productDraw.productDrawId);
      if (jokerDrawId) {
        return Object.values(_classPrivateFieldGet(_draws, this)[jokerDrawId]).filter(draw => draw.drawStateId < DRAW_STATES.CLOSED).find(jokerDraw => {
          const productOpenTime = new Date(productDraw.regOpenTime);
          const productCloseTime = new Date(productDraw.regCloseTime);
          const jokerOpenTime = new Date(jokerDraw.regOpenTime);
          const jokerCloseTime = new Date(jokerDraw.regCloseTime);
          if (dateFns.isSameDay(productOpenTime, jokerOpenTime)) return true;
          if (dateFns.isSameDay(productCloseTime, jokerOpenTime)) return false;
          return dateFns.isSameDay(productCloseTime, jokerCloseTime);
        });
      }
    });
    _classPrivateFieldInitSpec(this, _fetchJackpots, async products => {
      const promise = (async () => {
        try {
          await _classPrivateFieldGet(_fetchingJackpots, this);
        } catch (error) {
          logger.info('Previous jackpots fetch failed', error);
        }
        if (!_classPrivateFieldGet(_jackpots, this)) {
          try {
            _classPrivateFieldSet(_jackpots, this, await fetchJackpots(Object.values(_classPrivateFieldGet(_draws, this)).flatMap(Object.values)));
          } catch (error) {
            logger.warn('Draws.#fetchJackpots failed to fetch jackpots', error);
            throw new Error("Failed to fetch jackpots");
          }
        }
        const drawIds = toProductDrawIds({
          products
        }).map(productDrawId => {
          var _classPrivateFieldGet4;
          return {
            productId: productDrawId,
            drawNumber: (_classPrivateFieldGet4 = _classPrivateFieldGet(_firstPlayableDraws, this)[productDrawId]) === null || _classPrivateFieldGet4 === void 0 ? void 0 : _classPrivateFieldGet4.drawNumber
          };
        }).filter(_ref7 => {
          let {
            productId,
            drawNumber
          } = _ref7;
          return !productMapping.isKeno(productId) && !productMapping.isJoker(productId) && !_classPrivateFieldGet(_jackpots, this).find(jackpot => productMapping.isSameProduct(productId, jackpot.productId) && drawNumber === jackpot.drawNumber);
        });
        if (drawIds.length) {
          var _jackpots3;
          let jackpots;
          try {
            jackpots = await fetchJackpotsByProductDraw(drawIds);
          } catch (error) {
            logger.warn('Draws.#fetchJackpots failed to fetch jackpots by product draw', error);
            throw new Error("Failed to fetch jackpots by product draw");
          }
          if ((_jackpots3 = jackpots) !== null && _jackpots3 !== void 0 && _jackpots3.length) {
            const findMatchingJackpot = (jackpots, jackpot) => jackpots.find(_ref8 => {
              let {
                productId,
                winset,
                windiv
              } = _ref8;
              return productId === jackpot.productId && winset === jackpot.winset && windiv === jackpot.windiv;
            });
            _classPrivateFieldSet(_jackpots, this, _classPrivateFieldGet(_jackpots, this).map(jackpot => {
              var _findMatchingJackpot;
              return (_findMatchingJackpot = findMatchingJackpot(jackpots, jackpot)) !== null && _findMatchingJackpot !== void 0 ? _findMatchingJackpot : jackpot;
            }));
            _classPrivateFieldGet(_jackpots, this).push(...jackpots.filter(jackpot => !findMatchingJackpot(_classPrivateFieldGet(_jackpots, this), jackpot)));
          }
        }
      })();
      _classPrivateFieldSet(_fetchingJackpots, this, promise);
      return await promise;
    });
    if (!serverTime) {
      serverTime = Date.now();
      logger.info("Draws created without time reference. Will rely on client time: ".concat(serverTime));
    }
    const clientTimeOffset = dateFns.differenceInMilliseconds(Date.now(), serverTime);
    _classPrivateFieldSet(_clientTimeOffset, this, clientTimeOffset > 3000 || clientTimeOffset < 0 ? clientTimeOffset : 0);
    if (Math.abs(_classPrivateFieldGet(_clientTimeOffset, this)) > 60000) {
      logger.info("Client time offset: ".concat(_classPrivateFieldGet(_clientTimeOffset, this), " is more than a minute."));
    }
    if (_draws2.length) {
      _classPrivateFieldGet(_update, this).call(this, {
        draws: _draws2
      });
    }
    _classPrivateFieldSet(_jackpots, this, _jackpots2);
  }
  get clientNow() {
    return Date.now() - _classPrivateFieldGet(_clientTimeOffset, this);
  }

  async getOpenDraw(products) {
    const drawIds = toProductDrawIds({
      products,
      addJoker: true
    }).map(productDrawId => ({
      productDrawId
    }));
    await _classPrivateFieldGet(_fetch, this).call(this, drawIds);
    return this.findOpenDraw(products);
  }

  findOpenDraw(products) {
    const productDrawIds = toProductDrawIds({
      products
    });
    const openDraws = productDrawIds.map(productDrawId => _classPrivateFieldGet(_firstPlayableDraws, this)[productDrawId]).filter(firstPlayableDraw => (firstPlayableDraw === null || firstPlayableDraw === void 0 ? void 0 : firstPlayableDraw.drawStateId) === DRAW_STATES.OPEN);
    return productDrawIds.reduce((acc, productDrawId) => Object.assign(acc, {
      [productMapping.getProductItsId(productDrawId)]: openDraws.find(draw => draw.productDrawId === productDrawId)
    }), {});
  }

  async getFirstPlayableDraw(products) {
    const drawIds = toProductDrawIds({
      products,
      addJoker: true
    }).map(productDrawId => ({
      productDrawId
    }));
    await _classPrivateFieldGet(_fetch, this).call(this, drawIds);
    return this.findFirstPlayableDraw(products);
  }

  findFirstPlayableDraw(products) {
    return toProductDrawIds({
      products
    }).reduce((acc, productDrawId) => Object.assign(acc, {
      [productMapping.getProductItsId(productDrawId)]: _classPrivateFieldGet(_firstPlayableDraws, this)[productDrawId]
    }), {});
  }

  async getNextDraw(products) {
    const drawsToFetch = [];
    const firstPlayableDraws = await this.getFirstPlayableDraw(products);
    Object.values(firstPlayableDraws).forEach(draw => {
      if ((draw === null || draw === void 0 ? void 0 : draw.drawStateId) > DRAW_STATES.DEFINED) {
        drawsToFetch.push({
          productDrawId: draw.productDrawId,
          drawNumber: draw.drawNumber + 1
        });
        if (draw.jokerDraw) {
          drawsToFetch.push({
            productDrawId: draw.jokerDraw.productDrawId,
            drawNumber: draw.jokerDraw.drawNumber + 1
          });
        }
      }
    });
    await _classPrivateFieldGet(_fetch, this).call(this, drawsToFetch);
    return this.findNextDraw(products);
  }

  findNextDraw(products) {
    return toProductDrawIds({
      products
    }).reduce((acc, productDrawId) => {
      const productDraw = Object.values(_classPrivateFieldGet(_draws, this)[productDrawId]).find(draw => draw.drawStateId === DRAW_STATES.DEFINED);
      const jokerDraw = _classPrivateFieldGet(_findCorrespondingJokerDraw, this).call(this, productDraw);
      return Object.assign(acc, {
        [productMapping.getProductItsId(productDrawId)]: _objectSpread(_objectSpread({}, productDraw), jokerDraw && {
          jokerDraw
        })
      });
    }, {});
  }

  async getDraw(drawOptions) {
    drawOptions = formatDrawOptions(drawOptions);
    const products = drawOptions.map(_ref9 => {
      let {
        product
      } = _ref9;
      return product;
    });
    await this.getFirstPlayableDraw(products);
    const drawsToFetch = drawOptions.filter(_ref0 => {
      let {
        product,
        days,
        sameRegCloseDayAs
      } = _ref0;
      return productMapping.isDaily(product) && (days || sameRegCloseDayAs);
    }).reduce((drawsToFetch, _ref1) => {
      let {
        product,
        days,
        sameRegCloseDayAs
      } = _ref1;
      if (sameRegCloseDayAs) {
        const matchDraw = _classPrivateFieldGet(_firstPlayableDraws, this)[sameRegCloseDayAs];
        if (matchDraw) {
          days = [new Date(matchDraw.regCloseTime).getDay()];
        }
      }
      if (days) {
        const firstPlayableDraw = _classPrivateFieldGet(_firstPlayableDraws, this)[product];
        const startDay = new Date(firstPlayableDraw.regCloseTime).getDay();
        days.forEach(day => {
          const offset = day > startDay ? day - startDay : day - startDay + 7;
          drawsToFetch.push({
            productDrawId: product,
            drawNumber: firstPlayableDraw.drawNumber + offset
          });
        });
      }
      return drawsToFetch;
    }, []);
    await _classPrivateFieldGet(_fetch, this).call(this, drawsToFetch);
    return this.findDraw(drawOptions);
  }

  findDraw(drawOptions) {
    const findPlayableDraw = (productDrawId, findFn) => Object.values(_classPrivateFieldGet(_draws, this)[productDrawId]).filter(draw => draw.drawStateId < DRAW_STATES.CLOSED).find(findFn);
    return formatDrawOptions(drawOptions).reduce((selectedDraws, _ref10) => {
      let {
        id,
        product,
        days,
        sameRegCloseDayAs
      } = _ref10;
      let draw;
      if (sameRegCloseDayAs) {
        var _selectedDraws$find;
        const regCloseTime = (_selectedDraws$find = selectedDraws.find(draw => draw.productDrawId === sameRegCloseDayAs)) === null || _selectedDraws$find === void 0 ? void 0 : _selectedDraws$find.regCloseTime;
        if (regCloseTime) {
          const matchDate = new Date(regCloseTime);
          draw = findPlayableDraw(product, draw => dateFns.isSameDay(new Date(draw.regCloseTime), matchDate));
        }
      } else if (days) {
        draw = findPlayableDraw(product, draw => days.includes(dateFns.getDay(new Date(draw.regCloseTime))));
      } else {
        draw = _classPrivateFieldGet(_firstPlayableDraws, this)[product];
      }
      if (draw) {
        selectedDraws.push(_objectSpread(_objectSpread({}, draw), id && {
          id
        }));
      }
      return selectedDraws;
    }, []).sort((a, b) => new Date(a.regCloseTime).getTime() - new Date(b.regCloseTime).getTime());
  }
  findJackpot(products) {
    const getJackpot = options => {
      var _classPrivateFieldGet5;
      return svs.numbergames.jackpot.getJackpot(_objectSpread({
        jackpots: _classPrivateFieldGet(_jackpots, this),
        drawNumber: (_classPrivateFieldGet5 = _classPrivateFieldGet(_firstPlayableDraws, this)[productMapping.getProductDrawId(options.product)]) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.drawNumber
      }, options));
    };
    if (!products) return;
    if (!Array.isArray(products)) products = [products];
    return products.map(product => ['string', 'number'].includes(typeof product) ? {
      product
    } : product).reduce((acc, options) => Object.assign(acc, {
      [options.product]: getJackpot(options)
    }), {});
  }
  async getJackpot(products) {
    if (!Array.isArray(products)) products = [products];
    const productsToFetch = products.map(product => {
      var _product$product;
      return (_product$product = product === null || product === void 0 ? void 0 : product.product) !== null && _product$product !== void 0 ? _product$product : product;
    });
    await _classPrivateFieldGet(_fetchJackpots, this).call(this, productsToFetch);
    return this.findJackpot(products);
  }
}
let drawsSingleton;
svs.numbergames.draws.internal.getDrawsSingleton = () => {
  if (!drawsSingleton) {
    drawsSingleton = new Draws(svs.numbergames.draws.data);
  }
  return drawsSingleton;
};

 })(window);